import React from "react";
import "./TransactionSkeleton.css";

const SalesBookSkeleton = () => {
  return (
    <div className='slense-salesbook-skeleton-body'>
      <div className='slense-salesbook-skeleton-container'>
        {/* Header */}
        <div className='slense-salesbook-skeleton-header'>
          <div className='slense-salesbook-skeleton-tabs'>
            <div className='slense-salesbook-skeleton-tab'>
              <div className='slense-salesbook-skeleton-tab-text'></div>
              <div className='slense-salesbook-skeleton-badge'></div>
            </div>
            <div className='slense-salesbook-skeleton-tab'>
              <div className='slense-salesbook-skeleton-tab-text'></div>
              <div className='slense-salesbook-skeleton-badge'></div>
            </div>
          </div>

          <div className='slense-salesbook-skeleton-search-section'>
            <div className='slense-salesbook-skeleton-search'></div>
            <div className='slense-salesbook-skeleton-icon-btn'></div>
            <div className='slense-salesbook-skeleton-date-btn'></div>
          </div>
        </div>

        {/* Table Header */}
        <div className='slense-salesbook-skeleton-table-header'>
          <div className='slense-salesbook-skeleton-th'></div>
          <div className='slense-salesbook-skeleton-th'></div>
          <div className='slense-salesbook-skeleton-th'></div>
          <div className='slense-salesbook-skeleton-th'></div>
          <div className='slense-salesbook-skeleton-th'></div>
        </div>

        {/* Content */}
        <div className='slense-salesbook-skeleton-content'>
          {/* Table */}
          <div className='slense-salesbook-skeleton-table'>
            {[...Array(5)].map((_, index) => (
              <div key={index} className='slense-salesbook-skeleton-row'>
                <div className='slense-salesbook-skeleton-product'>
                  <div className='slense-salesbook-skeleton-avatar'></div>
                  <div className='slense-salesbook-skeleton-product-details'>
                    <div className='slense-salesbook-skeleton-product-name'></div>
                    <div className='slense-salesbook-skeleton-product-extra'></div>
                  </div>
                </div>
                <div className='slense-salesbook-skeleton-status'></div>
                <div className='slense-salesbook-skeleton-price'></div>
                <div className='slense-salesbook-skeleton-price'></div>
                <div className='slense-salesbook-skeleton-view-btn'></div>
              </div>
            ))}
          </div>

          {/* Sidebar Stats */}
          <div className='slense-salesbook-skeleton-sidebar'>
            {[...Array(4)].map((_, index) => (
              <div key={index} className='slense-salesbook-skeleton-stat-card'>
                <div className='slense-salesbook-skeleton-stat-header'>
                  <div className='slense-salesbook-skeleton-stat-icon'></div>
                  <div className='slense-salesbook-skeleton-stat-info'>
                    <div className='slense-salesbook-skeleton-stat-label'></div>
                    <div className='slense-salesbook-skeleton-stat-value'></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Actions */}
        <div className='slense-salesbook-skeleton-actions'>
          <div className='slense-salesbook-skeleton-btn'></div>
          <div className='slense-salesbook-skeleton-btn slense-salesbook-skeleton-btn-primary'></div>
        </div>
      </div>
    </div>
  );
};

export default SalesBookSkeleton;
